module.exports = __webpack_public_path__ + "img/img-14.a54ae161.png";